import { render } from "./Main-Login.vue?vue&type=template&id=5e9ba939"
import script from "./Main-Login.vue?vue&type=script&lang=js"
export * from "./Main-Login.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__